/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { All } from './All';
import {
    AllFromJSON,
    AllFromJSONTyped,
    AllToJSON,
    AllToJSONTyped,
} from './All';
import type { Call } from './Call';
import {
    CallFromJSON,
    CallFromJSONTyped,
    CallToJSON,
    CallToJSONTyped,
} from './Call';
import type { MatchingCriteria } from './MatchingCriteria';
import {
    MatchingCriteriaFromJSON,
    MatchingCriteriaFromJSONTyped,
    MatchingCriteriaToJSON,
    MatchingCriteriaToJSONTyped,
} from './MatchingCriteria';

/**
 * 
 * @export
 * @interface IncludeControls
 */
export interface IncludeControls {
    /**
     * 
     * @type {string}
     * @memberof IncludeControls
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof IncludeControls
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof IncludeControls
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof IncludeControls
     */
    description?: string;
    /**
     * 
     * @type {any}
     * @memberof IncludeControls
     */
    profile?: any | null;
    /**
     * 
     * @type {string}
     * @memberof IncludeControls
     */
    controlIds?: string;
    /**
     * 
     * @type {Array<MatchingCriteria>}
     * @memberof IncludeControls
     */
    matchingCriteria?: Array<MatchingCriteria>;
    /**
     * 
     * @type {Array<Call>}
     * @memberof IncludeControls
     */
    calls?: Array<Call>;
    /**
     * 
     * @type {Array<All>}
     * @memberof IncludeControls
     */
    alls?: Array<All>;
}

/**
 * Check if a given object implements the IncludeControls interface.
 */
export function instanceOfIncludeControls(value: object): value is IncludeControls {
    return true;
}

export function IncludeControlsFromJSON(json: any): IncludeControls {
    return IncludeControlsFromJSONTyped(json, false);
}

export function IncludeControlsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncludeControls {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'profile': json['profile'] == null ? undefined : json['profile'],
        'controlIds': json['controlIds'] == null ? undefined : json['controlIds'],
        'matchingCriteria': json['matchingCriteria'] == null ? undefined : ((json['matchingCriteria'] as Array<any>).map(MatchingCriteriaFromJSON)),
        'calls': json['calls'] == null ? undefined : ((json['calls'] as Array<any>).map(CallFromJSON)),
        'alls': json['alls'] == null ? undefined : ((json['alls'] as Array<any>).map(AllFromJSON)),
    };
}

export function IncludeControlsToJSON(json: any): IncludeControls {
    return IncludeControlsToJSONTyped(json, false);
}

export function IncludeControlsToJSONTyped(value?: IncludeControls | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'uuid': value['uuid'],
        'description': value['description'],
        'profile': value['profile'],
        'controlIds': value['controlIds'],
        'matchingCriteria': value['matchingCriteria'] == null ? undefined : ((value['matchingCriteria'] as Array<any>).map(MatchingCriteriaToJSON)),
        'calls': value['calls'] == null ? undefined : ((value['calls'] as Array<any>).map(CallToJSON)),
        'alls': value['alls'] == null ? undefined : ((value['alls'] as Array<any>).map(AllToJSON)),
    };
}

